import { Component, OnInit, ChangeDetectorRef, Inject, InjectionToken } from '@angular/core';
import _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { EventBusService } from '@root/shared/service/event-bus.service';
import { MESSAGE_DEFAULT_CONFIG, MessageConfig } from '../message.config';

@Component({
  selector: 'host-message-container',
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss'],
})
export class MessageContainerComponent implements OnInit {
  rightMessages = [];
  centerMessages = [];
  hideMessagesMap = {};
  constructor(
    private ebsService: EventBusService,
    private activatedRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    @Inject(MESSAGE_DEFAULT_CONFIG) private defaultConfig: MessageConfig
  ) {}

  ngOnInit() {
    /**
     * 产品要求路由变化的时候要重新显示弹窗。。。
     */
    this.subscribeRouteChange();
  }

  subscribeRouteChange() {
    this.ebsService.eventBus$.subscribe(res => {
      this.resetMessageVisibility();
    });
  }

  removeMessage(messageId: number, option = this.defaultConfig) {
    const messages =
      option.position === 'center' ? this.centerMessages : this.rightMessages;
    _.remove(messages, { type: messageId });
    this.changeDetector.detectChanges();
  }
  removeMessageAll() {
    this.rightMessages = [];
    this.centerMessages = [];
    this.changeDetector.detectChanges();
  }
  replaceMessage(messageId: number, messageData, option = this.defaultConfig) {
    /**
     * 思路：
     * 先在中间的messages里面找，然后在右边的messages里面找
     * 如果在中间找到，但是option里面的position='right', 则删除中间的，右边新建一个
     * 如果在右边找到，但是option里面的position='center', 则删除右边的，中间新建一个
     * 都没找到，则根据option新建一个
     */

    _.remove(this.centerMessages, { type: messageId });
    _.remove(this.rightMessages, { type: messageId });

    this.createMessage(messageData, option);
  }

  /**
   * 隐藏某种类型在某种状态下的信息
   * 例如：{ 1: 2 }，隐藏类型为1，在状态为2时的信息
   */
  hideMessage(messageData) {
    this.hideMessagesMap[messageData.type] = messageData.status;
    this.changeDetector.detectChanges();
  }

  resetMessageVisibility() {
    this.hideMessagesMap = [];
    this.changeDetector.detectChanges();
  }

  createMessage(messageData, option = this.defaultConfig) {
    if (!option) {
      option = { position: 'right' };
    }
    if (option.position === 'center') {
      this.centerMessages.push(messageData);
    } else {
      this.rightMessages.push(messageData);
    }
    this.changeDetector.detectChanges();
  }
}
